export default __webpack_public_path__ + "static/media/tag-price.f14d06e5.svg";